import type { ResellerPermission } from "@xop-any-time/shared";
import { PERMISSION_SECTIONS } from "@xop-any-time/shared";
import { Box, Typography } from "@mui/material";
import { Lock } from "lucide-react";
import type { JSX } from "react";

/**
 * What a page shows in place of itself when the person lacks its `view`
 * permission, or in place of a result when crm-api refused a call by key.
 *
 * A PANEL, NOT A REDIRECT. Bouncing to "/" would hide which section was
 * refused and, for a person with no sections at all, loop. Naming the key is
 * deliberate: it is what they need to ask their owner for.
 */
export function NoAccessPanel({ permission }: { permission: ResellerPermission | string }): JSX.Element {
  const section = permission.split(":")[0] ?? permission;
  const label = (PERMISSION_SECTIONS as Record<string, string>)[section] ?? section;
  return (
    <Box
      data-testid="no-access-panel"
      role="status"
      sx={{ display: "grid", placeItems: "center", textAlign: "center", py: 8, px: 3, gap: 1.5 }}
    >
      <Box sx={{ color: "text.disabled" }}><Lock size={28} /></Box>
      <Typography variant="h6">No access to {label}</Typography>
      <Typography sx={{ color: "text.secondary", maxWidth: 440 }}>
        Ask an owner at your company to grant <Box component="code" sx={{ fontSize: 13 }}>{permission}</Box>.
      </Typography>
    </Box>
  );
}
